import { useTranslation } from 'react-i18next'
import { ArrowUpRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { QuickSuggestionProps } from '@brochure/shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  if (suggestions.length === 0) return null

  return (
    <div className="flex flex-col gap-2">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          type="button"
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className={cn(
            'group relative w-full flex items-center justify-between gap-3',
            'bg-white border border-argan/40 px-4 py-3 text-left',
            'transition-all duration-300',
            'hover:border-bruno hover:bg-cream-soft hover:shadow-[0_4px_12px_-4px_rgba(59,49,46,0.15)]',
            'disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-argan/40 disabled:hover:bg-white'
          )}
        >
          <span className="text-[13px] font-normal text-bruno leading-snug">
            {t(suggestion.labelKey)}
          </span>
          <span
            className={cn(
              'shrink-0 w-6 h-6 inline-flex items-center justify-center',
              'border border-argan/40 text-argan-deep',
              'transition-all duration-300',
              'group-hover:bg-bruno group-hover:border-bruno group-hover:text-cream'
            )}
          >
            <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
          </span>
        </button>
      ))}
    </div>
  )
}
